module.exports = __webpack_public_path__ + "static/media/homework-completion-screen-header.b387f96b.png";